// TCUBE FITNESS™ Mock Data

export const brandInfo = {
  name: "TCUBE FITNESS",
  tagline: "Treat • Train • Transform",
  description: "Doctor-Guided Health, Nutrition & Fitness",
  shortDescription: "TCUBE FITNESS™ is a 100% online, doctor-guided health, nutrition, and fitness platform offering personalized programs supervised by healthcare professionals."
};

// Programs (replaces old services)
export const programs = [
  {
    id: "diabetes-management",
    icon: "Droplet",
    name: "Diabetes Management Program",
    slug: "/medical-nutrition-therapy",
    color: "teal",
    gradient: "from-teal-600 to-emerald-500",
    bullets: [
      "Doctor-supervised nutrition for Diabetes",
      "Personalized meal plans for blood sugar management",
      "Weight management and metabolic health support",
      "Medication-aware nutrition guidance",
      "Lifestyle coaching for sustainable healthy habits",
      "Regular progress tracking and ongoing support"
    ]
  },
  {
    id: "fertility-nutrition",
    icon: "Baby",
    name: "Fertility Nutrition Program",
    slug: "/fertility-nutrition",
    color: "pink",
    gradient: "from-pink-500 to-rose-500",
    bullets: [
      "Nutrition support for couples planning conception",
      "Hormonal and reproductive health optimization",
      "Personalized meal plans based on medical evaluation",
      "Doctor-guided, medically supervised approach",
      "Lifestyle guidance to support conception",
      "Regular progress tracking and ongoing support"
    ]
  },
  {
    id: "pregnancy-nutrition",
    icon: "Heart",
    name: "Pregnancy Nutrition Plan",
    slug: "/pregnancy-nutrition",
    color: "blue",
    gradient: "from-blue-500 to-cyan-500",
    bullets: [
      "Trimester-specific nutrition guidance",
      "Maternal and fetal health support",
      "Personalized meal plans for a healthy pregnancy",
      "Supervised by healthcare professionals",
      "Safe, nutrient-focused dietary support",
      "Regular progress tracking and ongoing support"
    ]
  },
  {
    id: "postpartum-recovery",
    icon: "Apple",
    name: "Postpartum Recovery Program",
    slug: "/postpartum-recovery",
    color: "emerald",
    gradient: "from-emerald-500 to-green-500",
    bullets: [
      "Recovery-focused nutrition after childbirth",
      "Breastfeeding-friendly meal planning",
      "Gradual return to health and fitness",
      "Nutrition to support healing and energy",
      "Medical oversight throughout recovery",
      "Regular progress tracking and ongoing support"
    ]
  },
  {
    id: "online-fitness-coaching",
    icon: "Dumbbell",
    name: "Online Fitness Coaching",
    slug: "/online-fitness-coaching",
    color: "orange",
    gradient: "from-orange-500 to-amber-500",
    bullets: [
      "Personalized workouts for home or gym",
      "Doctor-supervised exercise progression",
      "Weekly coaching and progress tracking",
      "Safe, injury-aware training approach",
      "Nutrition and lifestyle guidance alongside workouts",
      "Regular progress tracking and ongoing support"
    ]
  }
];

// Medical team: named experts plus specialist network
export const medicalTeam = [
  {
    id: 1,
    isLead: true,
    name: "Dr. Pooja Sree",
    role: "Founder & Medical Lead",
    color: "blue",
    expertise: ["Preventive Health", "Metabolic Wellness", "Sustainable Fat Loss", "Lifestyle Medicine"],
    description: "Dr. Pooja Sree leads TCUBE FITNESS™ with an evidence-based, doctor-led approach to preventive healthcare and lifestyle transformation. She focuses on metabolic wellness, sustainable fat loss, lifestyle medicine and evidence-based fitness transformation through scientifically guided lifestyle strategies.",
    philosophy: "Fitness without medical insight is risky. Lifestyle change guided by medicine is what creates long-term results.",
    specialty: "General Medicine Physician · Sports Nutrition Expert",
    qualifications: "MBBS, DNB General Medicine, Diploma in Sports Nutrition",
    icon: "Stethoscope",
    focus: "Preventive health, metabolic wellness, sustainable fat loss, lifestyle medicine, evidence-based fitness transformation, and long-term health optimization through scientifically guided lifestyle strategies."
  },
  {
    id: 2,
    isLead: false,
    name: "K. Pavani",
    role: "Clinical Nutritionist",
    color: "emerald",
    expertise: ["Personalized Nutrition Planning", "Evidence-Based Nutrition Guidance", "Weight Management", "Sustainable Habit Development"],
    description: "Pavani specializes in personalized nutrition planning, evidence-based nutrition guidance and lifestyle nutrition support. She translates clinical nutrition science into practical, sustainable plans tailored to individual health goals.",
    philosophy: "Nutrition guidance must be realistic, evidence-based and sustainable, not restrictive or fashionable.",
    specialty: "Personalized Nutrition Planning & Lifestyle Nutrition",
    qualifications: "BSc, MSc Nutrition",
    icon: "Apple",
    focus: "Personalized nutrition planning, weight management, evidence-based nutrition guidance, lifestyle nutrition support, and sustainable healthy habit development tailored to individual health goals."
  },
  {
    id: 3,
    isLead: false,
    name: "Dr. Mrudula",
    role: "Consultant Obstetrician & Gynecologist",
    color: "pink",
    expertise: ["Women's Health", "Hormonal Wellness", "PMOS Management", "Pregnancy & Fertility Care"],
    description: "Dr. Mrudula focuses on women's health, hormonal wellness, PMOS management, pregnancy care and fertility-focused lifestyle guidance. She integrates preventive gynecological care with evidence-based lifestyle support.",
    philosophy: "Women's health deserves specialized, gentle and scientifically guided care at every life stage.",
    specialty: "Women's Health · PMOS · Pregnancy · Fertility",
    qualifications: "MS Obstetrics & Gynecology",
    icon: "Heart",
    focus: "Women's health, hormonal wellness, PMOS management, pregnancy care, fertility-focused lifestyle guidance, and preventive gynecological health optimization."
  },
  {
    id: 4,
    isLead: false,
    isNetwork: true,
    name: "Our Specialist Network",
    role: "11+ Gynecology & Fertility Specialists",
    color: "cyan",
    expertise: ["Gynecology Consultations", "Fertility Support", "Coordinated Specialist Care", "Regional Reach"],
    description: "We collaborate with 11+ experienced gynecology and infertility specialists across major cities in both Telugu states to provide comprehensive women's health, fertility support, and coordinated expert medical guidance through trusted specialist care.",
    philosophy: "A specialist network ensures every client has access to the right expertise at the right time.",
    specialty: "Comprehensive Women's Health & Fertility Support",
    icon: "Users",
    focus: "We collaborate with 11+ experienced gynecology and infertility specialists across major cities in both Telugu states to provide comprehensive women's health, fertility support, and coordinated expert medical guidance."
  }
];

export const credentialBadges = [
  "MBBS Qualified",
  "DNB General Medicine",
  "MSc Nutrition",
  "MS Obstetrics & Gynecology",
  "Sports Nutrition"
];

// Problem section pain points
export const problemPoints = [
  {
    emoji: "🤔",
    text: "Confused about what to eat during pregnancy or while trying to conceive?"
  },
  {
    emoji: "😓",
    text: "Struggling with PMOS, hormonal imbalance, or fertility-related concerns?"
  },
  {
    emoji: "💪",
    text: "Want to get fit safely with proper medical guidance?"
  },
  {
    emoji: "🌿",
    text: "Tired of generic influencer diet plans that don't suit your body?"
  }
];

// How It Works steps
export const howItWorksSteps = [
  {
    step: 1,
    title: "Book a Free Consultation",
    description: "Speak with our team about your goals and concerns."
  },
  {
    step: 2,
    title: "Receive Your Personalized Plan",
    description: "Get a customized nutrition and wellness plan designed for your needs."
  },
  {
    step: 3,
    title: "Ongoing Guidance & Support",
    description: "Stay connected with regular follow-ups and progress tracking."
  }
];

// Homepage FAQ
export const homeFaqs = [
  {
    question: "Is this suitable if I am trying to conceive?",
    answer: "Yes. Our Fertility Nutrition Program is designed for individuals and couples planning conception. We focus on doctor-guided nutrition and lifestyle support that may help create favourable conditions for reproductive health. Results vary based on individual medical factors."
  },
  {
    question: "Can I join during pregnancy?",
    answer: "Yes. Our Pregnancy Nutrition Plan provides trimester-specific guidance under medical supervision. We always recommend you continue routine care with your obstetrician alongside our nutrition support."
  },
  {
    question: "How does online coaching work?",
    answer: "After your free consultation, our team designs a personalized plan. You receive your plan digitally and stay connected with us via WhatsApp and scheduled follow-ups, all online from anywhere in the world."
  },
  {
    question: "How soon can I expect results?",
    answer: "Health changes happen gradually. Many clients begin to notice improvements in energy, digestion and overall wellbeing within the first few weeks. We focus on sustainable, evidence-informed progress rather than quick fixes."
  },
  {
    question: "Is my information kept private?",
    answer: "Yes. Your health information and personal details are kept strictly confidential and used only to design your personalized program. Please review our Privacy Policy for details."
  },
  {
    question: "Do you support international clients?",
    answer: "Yes. Our platform is 100% online and serves clients worldwide. Consultations are conducted at a time that suits your timezone."
  }
];

// Quiz questions for Find My Program
export const quizQuestions = [
  {
    id: "q1",
    question: "What is your primary health focus right now?",
    options: [
      { label: "Planning to conceive / trying for a baby", value: "fertility" },
      { label: "Currently pregnant", value: "pregnancy" },
      { label: "Recently delivered (within 12 months)", value: "postpartum" },
      { label: "General fitness, weight or wellness", value: "fitness" }
    ]
  },
  {
    id: "q2",
    question: "Are you currently managing any health condition?",
    options: [
      { label: "PMOS / hormonal imbalance", value: "pcos" },
      { label: "Thyroid / diabetes / metabolic", value: "metabolic" },
      { label: "None / general health", value: "none" },
      { label: "Prefer not to say", value: "private" }
    ]
  },
  {
    id: "q3",
    question: "How would you describe your activity level?",
    options: [
      { label: "Mostly sedentary", value: "sedentary" },
      { label: "Lightly active", value: "light" },
      { label: "Moderately active", value: "moderate" },
      { label: "Very active", value: "active" }
    ]
  },
  {
    id: "q4",
    question: "What kind of support are you looking for?",
    options: [
      { label: "Medical nutrition guidance", value: "nutrition" },
      { label: "Fitness coaching with safety oversight", value: "fitness" },
      { label: "A complete plan: nutrition + lifestyle", value: "complete" },
      { label: "Not sure, guide me", value: "guide" }
    ]
  }
];

export const formOptions = {
  genderOptions: [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "prefer_not_to_say", label: "Prefer not to say" }
  ],
  healthConditions: [
    { value: "diabetes_mellitus", label: "Diabetes Mellitus" },
    { value: "thyroid_disorder", label: "Thyroid Disorder" },
    { value: "pcos_pcod", label: "PMOS" },
    { value: "antenatal_gestational_diabetes", label: "Antenatal Gestational Diabetes" },
    { value: "postpartum_obesity", label: "Postpartum Concerns" },
    { value: "obesity_weight", label: "Weight Concerns" },
    { value: "other_lifestyle", label: "Other Lifestyle-Related Conditions" },
    { value: "none", label: "None" }
  ],
  goals: [
    { value: "fat_loss", label: "Weight Management" },
    { value: "metabolic_health", label: "Improve Metabolic Health" },
    { value: "strength_fitness", label: "Strength & Fitness" },
    { value: "hormonal_balance", label: "PMOS / Hormonal Balance" },
    { value: "fertility_health", label: "Fertility & Conception Support" },
    { value: "pregnancy_nutrition", label: "Pregnancy / Postpartum Nutrition" },
    { value: "general_health", label: "General Health Improvement" }
  ],
  concerns: [
    { value: "fertility", label: "Fertility / Conception support" },
    { value: "pregnancy", label: "Pregnancy nutrition" },
    { value: "postpartum", label: "Postpartum recovery" },
    { value: "pcos", label: "PMOS / Hormonal concerns" },
    { value: "diabetic", label: "Diabetic" },
    { value: "pre_diabetic", label: "Pre-diabetic" },
    { value: "fitness", label: "General fitness" },
    { value: "other", label: "Other" }
  ],
  consultationFor: [
    { value: "myself", label: "Myself" },
    { value: "my_husband", label: "My Husband" },
    { value: "my_wife", label: "My Wife" },
    { value: "my_mother", label: "My Mother" },
    { value: "my_father", label: "My Father" },
    { value: "my_child", label: "My Child" },
    { value: "my_sibling", label: "My Sibling" },
    { value: "my_friend", label: "My Friend" },
    { value: "other", label: "Other" }
  ]
};

// Genuine client reviews (shared with consent). Individual results vary.
export const clientReviews = [
  {
    id: "amruta-gvb-lakshmi",
    rating: 5,
    title: "Highly Recommendable",
    program: "Diabetes Management",
    text: [
      "Highly recommendable. We are extremely happy with the guidance and support provided by Dr. Pooja, who is also a nutritionist.",
      "My mom, 62 years old, and her personalized diet plan was practical, balanced, and easy to follow with regular exercise and following the diet and continuing her prescribed medicines. Her diabetes is now very well controlled, and her levels are within normal range.",
      "We truly appreciate her personal attention, regular guidance, and motivation to maintain a healthy lifestyle. Thank you for helping her make such a positive change. Highly recommendable for anyone who is looking for effective nutritionist and diabetes management with a doctor."
    ],
    name: "Amruta",
    context: "Daughter of GVB Lakshmi"
  },
  {
    id: "sustainable-approach",
    rating: 5,
    title: "A Sustainable Approach That Finally Worked for Me",
    program: "Nutrition & Fitness",
    highlights: [
      { label: "Starting Weight", value: "103.8 kg" },
      { label: "Current Weight", value: "92.3 kg" },
      { label: "Duration", value: "67 days" },
      { label: "Waist", value: "-2 inches" }
    ],
    text: [
      "I don't want to disclose my name, but I wanted to share my experience with Dr. Pooja and the nutrition and fitness guidance I've been receiving throughout my journey. This is my third month with her, and I wanted to share both my story and my review.",
      "I started at 103.8 kg. With her diet and workout plans, I am now at 92.3 kg after 67 days. She had explained to me that the initial 2 to 3 kg would mostly be water loss, but I am extremely happy with the rest of the weight I have lost.",
      "I can genuinely see a difference in myself. Earlier, I used to experience shortness of breath while walking even a few hundred meters. Right now, I can walk 6 to 7 km without a break. That change in my weight has made a huge difference to my stamina and overall fitness.",
      "I have also lost two inches from my waist, and I can feel the difference in all my T-shirts and clothes.",
      "I have tried to lose weight many times before, but I would give up very soon because the extreme diets I followed were difficult to sustain. What made Dr. Pooja's approach different was that her plan didn't feel like an extreme diet or something I had to force myself to follow. It was practical, comfortable, and flexible enough to fit into my routine.",
      "She didn't make me feel like I had to completely give up the foods I enjoy. Instead, she taught me how to include different foods in the right quantities. That made the diet feel like something I could actually continue long-term, rather than something I would follow for a few weeks and eventually quit.",
      "After my first week, during our first call, she made sure I was feeling alright and asked me how I had felt throughout the week. Based on my inputs and how I was feeling, she made multiple changes to my diet and macros. This regular monitoring and personalization made a big difference. Whenever something wasn't working for me, we discussed it and adjusted the plan instead of me feeling forced to continue with something I couldn't sustain.",
      "That is probably the biggest reason I haven't given up this time. The plan keeps adapting to me, rather than expecting me to completely change myself for the diet.",
      "I know this is just the beginning, but it will go on until I reach the number I have in my mind. I'm really happy with the progress I've made so far and looking forward to continuing this journey with Dr. Pooja."
    ],
    name: "Client",
    context: "3 months into the nutrition & fitness journey"
  },
  {
    id: "sudarshan-diabetes-gut",
    rating: 5,
    title: "A Remarkable Change in Diabetes & Gut Health",
    program: "Diabetes Management",
    text: [
      "I am 62 years old and had an HbA1c of around 10.8 in March. After joining Tcubefitness, my HbA1c has come down to 6.2 in August. I have also lost around 4 kg over the past six months.",
      "The diet is sustainable and I feel better now, and my gut issues have resolved. Initially, I used to have constipation. Now, my bowel movements are regular.",
      "Dr. Pooja and her team were very helpful throughout my entire journey."
    ],
    name: "Sudarshan",
    context: "62 years old | 6-month journey",
    clinicalProgress: [
      { label: "HbA1c", value: "10.8% to 6.2%" },
      { label: "Weight", value: "~4 kg reduction" },
      { label: "Medication at start", value: "Oxramet SXR 10/100/500 (morning) + Zoryl M2 (night)" },
      { label: "Current medication", value: "Oxramet SXR 10/100/500 (morning)" },
      { label: "Medication change", value: "Zoryl M2 discontinued by his general physician" }
    ],
    clinicalNote: "Medication changes were made by the client's treating physician."
  },
  {
    id: "aruna-diabetes",
    rating: 5,
    title: "A Big Change in My Health",
    program: "Diabetes Management",
    highlights: [
      { label: "Starting HbA1c", value: "8.7%" },
      { label: "Current HbA1c", value: "6.6%" }
    ],
    text: [
      "I am 53 years old and when I started with Dr. Pooja, my HbA1c was 8.7%. I knew I had to make changes, but I was always worried about whether I could actually follow a diet for a long time.",
      "What I liked about Dr. Pooja's plan was that it was practical. I could eat normal home food and didn't feel like I was on some very strict diet. She explained what I should eat, how much I should eat and what small changes I needed to make.",
      "With the diet, exercise and regular follow-ups, my HbA1c has now come down to 6.6%. I feel much better and more confident about managing my food and lifestyle.",
      "Whenever I had any difficulty, I could discuss it with Dr. Pooja and she would make changes according to what was working for me. That made it much easier to stay consistent.",
      "I'm very happy with the progress I have made and I'm going to continue following the same lifestyle."
    ],
    name: "Aruna",
    context: "53 years old"
  },
  {
    id: "mahesh-prediabetes",
    rating: 5,
    title: "Glad I Took Action Early",
    program: "Prediabetes Management",
    highlights: [
      { label: "Starting HbA1c", value: "6.0%" },
      { label: "Current HbA1c", value: "5.5%" }
    ],
    text: [
      "I am 38 years old and when I started with Dr. Pooja, my HbA1c was 6.0%, which was in the prediabetic range. I knew I needed to do something about it, but I didn't want to wait until it became a bigger problem.",
      "The diet was much easier than I expected. There was no feeling that I had to completely stop eating everything I liked. Dr. Pooja helped me understand portions, food choices and how to balance my meals.",
      "With the diet, exercise and regular follow-ups, my HbA1c has now come down to 5.5%. I'm happy that we were able to bring it back within the normal range.",
      "The biggest thing I learned is that I don't have to follow an extreme diet to get results. The plan was practical enough for me to continue with my regular work and lifestyle.",
      "I'm glad I started when I was prediabetic instead of ignoring it and waiting for it to become diabetes. Dr. Pooja and the team have been very supportive throughout."
    ],
    name: "Mahesh",
    context: "38 years old | Prediabetes"
  },
  {
    id: "mallikarjun-lakshmi-couple",
    rating: 5,
    title: "Managing Our Diabetes Together",
    program: "Couple Program",
    clinicalProgress: [
      { label: "Partner 1, 63 years", value: "HbA1c 8.1% to 6.7%" },
      { label: "Partner 2, 58 years", value: "HbA1c 7.6% to 6.4%" }
    ],
    text: [
      "We both joined Dr. Pooja's couple program because we wanted to take our health and diabetes management more seriously. I am 63 and my spouse is 58.",
      "When we started the program, our HbA1c levels were 8.1% and 7.6%, respectively. After following the diet plan and making practical changes to our daily routine, they have now come down to 6.7% and 6.4%.",
      "What worked well for us was that the diet was practical and easy to follow at home. We did not have to prepare completely different meals for each person. Instead, we learned how to manage portions and make better choices with the foods we already eat.",
      "Doing the program together also helped us stay consistent. We reminded each other about our diet and exercise, and gradually, these changes became part of our daily routine.",
      "Dr. Pooja was always available to guide us and make adjustments whenever needed. We never felt that the diet was too difficult or something we could follow only for a short period.",
      "We are very happy with the improvement in our HbA1c levels and, more importantly, with what we have learned about managing diabetes through sustainable lifestyle changes. We are continuing with the same approach and hope to keep our levels under control."
    ],
    name: "Mallikarjun & Lakshmi",
    context: "63 & 58 years old | Couple Program"
  },
  {
    id: "sandeep-elders-diabetes",
    rating: 5,
    title: "Remarkable Progress for Our 63-Year-Old Family Member",
    program: "Fitness & Nutrition for Elders",
    text: [
      "We are extremely happy with the Premium Fitness and Nutrition Plan for Elders by Dr. Pooja Sree.",
      "Our 63-year-old family member had been taking five different diabetes medications every day for a long time. After following Dr. Pooja Sree's personalised nutrition and fitness plan, we saw remarkable progress within just 45 days.",
      "Most significantly, her long-term treating doctor reduced her diabetes medications from five per day to just one.",
      "We are truly grateful for the personalised guidance, regular support, and focus on sustainable lifestyle changes. Highly recommended for elders and families looking for professional fitness and nutrition guidance."
    ],
    name: "Sandeep Darmhasetty",
    context: "Family member, 63 years old",
    clinicalProgress: [
      { label: "Duration", value: "45 days" },
      { label: "Medication at start", value: "5 diabetes medications per day" },
      { label: "Current medication", value: "1 diabetes medication per day" },
      { label: "Medication change", value: "Reduced by her long-term treating doctor" }
    ],
    clinicalNote: "Medication changes were made by the client's treating physician."
  },
  {
    id: "varun-parents-couple",
    rating: 5,
    title: "Peace of Mind for My Parents from Thousands of Miles Away",
    program: "Premium Couple Program",
    text: [
      "I came across a few of Dr. Pooja Sree's reels on Instagram while looking for help with my parents' health. The way she explained diabetes and food was simple and practical, so I scheduled a call just to understand how her program worked.",
      "After speaking with her, I felt comfortable enrolling my parents. I had been trying to convince them to take up a proper fitness and nutrition program for a long time, but they were always reluctant. Knowing that Dr. Pooja Sree is also a doctor and regularly works with patients with diabetes gave them much more confidence.",
      "My parents eventually joined her Premium Couple Program, and we have been incredibly happy with the experience. I live in the US, so being away from my parents can sometimes be worrying. Knowing that someone is regularly checking on them and that Dr. Pooja Sree and her team are just a message away gives me a lot of peace of mind.",
      "The changes have been very encouraging. My parents are fitter and healthier than I have seen them in a long time, and their HbA1c levels have improved significantly within around 60 days.",
      "The best part for me is that this isn't just a diet and workout program. They have learned how to eat mindfully and make better decisions even when they are outside their regular routine. Recently, they attended a five-day function and still managed their food much better than before, without their daily blood sugar readings fluctuating as much as we expected.",
      "As vegetarians, we had also followed many food myths for years. Dr. Pooja Sree helped my parents understand food better and make practical changes without making them feel like they were constantly on a restrictive diet.",
      "Being thousands of miles away, it is reassuring to know that my parents have someone regularly guiding them. I am genuinely grateful to Dr. Pooja Sree and her team for the support and the positive changes I have seen in my parents."
    ],
    name: "Varun",
    context: "Enrolled his parents | Based in the US"
  },
  {
    id: "sharvya-gut-fitness",
    rating: 5,
    title: "Progress I Hadn't Seen in Four Years",
    program: "Nutrition & Fitness",
    text: [
      "After trying quite a few fitness companies and coaches, especially the ones I found on Instagram, I came across Tcube Fitness while searching for a Telugu nutritionist. I was actually surprised to see that Dr. Pooja Sree was a doctor as well. I had already tried many things, so I thought, why not give this a try too?",
      "After joining, I realised that although fitness plans can look similar from the outside, the understanding behind them can be very different.",
      "The first thing she identified was that I had some gut issues. Earlier, whenever I tried increasing my protein intake, I used to struggle with it. She helped me understand that protein alone is not everything and that fibre and gut health are equally important. Instead of just pushing me into a fitness plan, she first focused on improving my gut health and then continued with my fitness journey.",
      "Honestly, that made a big difference. After nearly four years of working with different coaches, I finally started seeing readings and progress that I had never seen during all those years.",
      "One thing I really like about working with her is that she tries to understand the reason behind a problem. It's not always just about calories, macros, or giving everyone the same diet plan. That is something I personally found different.",
      "After about six weeks, I also started getting bored of eating similar foods every day. The team helped me with that too. I had a detailed call with their in-house chef, who suggested several recipes that suited my nutrition plan but still gave me enough variety to enjoy my food.",
      "Overall, I feel like I understand my body and food much better now. I'm really happy that I decided to give Tcube Fitness a try. Thank you, Dr. Pooja Sree and the entire Tcube Fitness team, for all the guidance and support."
    ],
    name: "Sharvya",
    context: "Nutrition & fitness journey"
  },
  {
    id: "alekhya-weight-gain",
    rating: 5,
    title: "A Weight Gain Journey That Finally Worked",
    program: "Weight Gain Program",
    text: [
      "Hi, I'm Alekhya. Meeting with Pooja and the team at TCube Fitness was the best decision for my health journey! I initially struggled with maintaining a proper diet, but Pooja's guidance turned everything around.",
      "She designed a weight gain diet and workout plan featuring a wide variety of meals, ensuring I never had to eat anything I didn't enjoy. While it was tough to follow through in the first few weeks, seeing actual weight gain and steady progress built up my confidence into a long-term lifestyle.",
      "The difference in my body and energy levels today is night and day. Huge thanks to Pooja and TCube Fitness for their patience and expertise."
    ],
    name: "Alekhya T",
    context: "Weight Gain Program"
  }
];

export const navigationLinks = [
  { name: "Home", href: "/" },
  { name: "Programs", href: "/#programs" },
  { name: "Health Analysis", href: "/health-analysis" },
  { name: "Calculators", href: "/calculators" },
  { name: "Reviews", href: "/reviews" },
  { name: "Resources", href: "/resources" },
  { name: "Blog", href: "/blog" },
  { name: "Book Free Consultation", href: "/book-consultation" }
];

// WhatsApp prefilled messages
export const whatsappMessages = {
  general: "Hi! I'd like to know more about TCUBE Fitness programs.",
  fertility: "Hi! I'm interested in your Fertility Nutrition Program. Could you share more details?",
  pregnancy: "Hi! I'd like to know about your Pregnancy Nutrition Plan.",
  fitness: "Hi! I'm interested in your general fitness coaching."
};

export const WHATSAPP_NUMBER = "919515901777";
export const WHATSAPP_DISPLAY = "+91 9515901777";
